// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2hvHV","row":"Node_row__Iypd7","label":"Node_label__1DzNt","footer":"Node_footer__2LKpJ"};